import axios from './axios';

const REFRESH_TOKEN_STORAGE_KEY = 'social.auth.refresh.v1';

const setToken = (accessToken) => {
  axios.defaults.headers.common[
    // eslint-disable-next-line dot-notation
    'Authorization'
  ] = `Bearer ${accessToken}`;
};

const clearToken = () => {
  delete axios.defaults.headers.common[
    // eslint-disable-next-line dot-notation
    'Authorization'
  ];
};

const setStoredRefreshToken = (refreshToken) => {
  if (typeof window === 'undefined' || !refreshToken) return;
  window.localStorage.setItem(REFRESH_TOKEN_STORAGE_KEY, refreshToken);
};

const getStoredRefreshToken = () => {
  if (typeof window === 'undefined') return null;
  return window.localStorage.getItem(REFRESH_TOKEN_STORAGE_KEY);
};

const clearStoredRefreshToken = () => {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(REFRESH_TOKEN_STORAGE_KEY);
};

export {
  setToken,
  clearToken,
  setStoredRefreshToken,
  getStoredRefreshToken,
  clearStoredRefreshToken,
};
